import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { msg } from '@philips-emr/tws-core/lib/services';

@Controller({ fragment: 'root' })
class MainController {

  @OnMount({ target: 'layout-root' })
  onRootLayoutMount(): void {
    document.title = msg('stipulator.application.name');
  }

}

export default MainController;
